import { render, staticRenderFns } from "./ProducerDataExport.vue?vue&type=template&id=b71ecfe2&"
import script from "./ProducerDataExport.vue?vue&type=script&lang=js&"
export * from "./ProducerDataExport.vue?vue&type=script&lang=js&"
import style0 from "./ProducerDataExport.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports